<template>
    <div class="header">
        <div class="bg"></div>
        <div class="w"><a href="#" class="logo">
            <!-- <img src="@/assets/logo.png" alt=""> -->
        </a>
        <div class="header-item">
            <ul>
                <!-- 首页改用router-link，对应路由 / 重定向到 /IndexViewVue -->
                <!-- <li><a href="">官网首页</a></li> -->
                 <li><router-link to="/">官网首页</router-link></li>
                <li><router-link to="/allGameViewVue">应用介绍</router-link></li>
                <li><router-link to="/twoGameViewVue">公司介绍</router-link></li>
                <li><router-link to="/threeGameViewVue">联系我们</router-link></li>
            </ul>
        </div>
        <!-- <div class="header-search2">
            <a href="">Top</a>
        </div> -->
        <!-- <div class="header-search">
            <input type="text" placeholder="综合搜索">
        </div>
        <div>
            <ul>
                <li>登录</li>
                <li>注册</li>
            </ul>
        </div> -->
    </div>
    </div>

</template>
<script>
export default {
    
}
</script>
<style scoped>

</style>